import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './company.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const CompanyDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const companyEntity = useAppSelector(state => state.company.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="companyDetailsHeading">
          <Translate contentKey="fleetSenseApp.company.detail.title">Company</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
            <dd>{companyEntity.id}</dd>
          </DoNotShowInProduction>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.company.name">Name</Translate>
            </span>
          </dt>
          <dd>{companyEntity.name}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="fleetSenseApp.company.type">Type</Translate>
            </span>
          </dt>
          <dd>{companyEntity.type}</dd>
          <dt>
            <span id="activated">
              <Translate contentKey="fleetSenseApp.company.activated">Activated</Translate>
            </span>
          </dt>
          <dd>{companyEntity.activated ? 'true' : 'false'}</dd>
          <dt>
            <span id="logo">
              <Translate contentKey="fleetSenseApp.company.logo">Logo</Translate>
            </span>
          </dt>
          <dd>
            {companyEntity.logoUrl ? (
              <div>
                {companyEntity.logoContentType ? (
                  <a onClick={openFile(companyEntity.logoContentType, companyEntity.logoUrl)}>
                    <img src={companyEntity.logoUrl} style={{ maxHeight: '100px' }} />
                  </a>
                ) : null}
                {/* <span>
                  {companyEntity.logoContentType}, {byteSize(companyEntity.logo)}
                </span> */}
              </div>
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/company" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/company/${companyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CompanyDetail;
